import { Modal } from 'antd';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../app/store';
import { selectTheme, showSupportPopup } from '../../../features/theme/themeSlice';

const HelpModal = () => {
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const theme = useAppSelector(selectTheme);
	const dispatch = useDispatch<AppDispatch>();
	const intl = useIntl();

	return (
		<Modal
			title={intl.formatMessage({ id: 'support', defaultMessage: 'Assistenza' })}
			centered
			visible={theme.popupSupport}
			footer={[]}
			onCancel={() => dispatch(showSupportPopup(false))}
			onOk={() => dispatch(showSupportPopup(false))}
		>
			<div className="modal-support">
				<div
					dangerouslySetInnerHTML={{
						__html: intl.formatMessage({ id: 'help.modal.text', defaultMessage: '' })
					}}
				></div>
				<div className="text-center mt-2">
					<a href="mailto:info@pgcompany.eu">
						<FormattedMessage id="send.support.request" />
					</a>
				</div>
				<div className="text-center mt-2">
				<FormattedMessage id="email.response.time" />
				</div>
			</div>
		</Modal>
	);
};

export default HelpModal;
